import SelectField from '../Shared/SelectField'
import { useTravelSearchContext } from '../../context/TravelSearchProvider'
import { useRoutes } from '../../Hooks/routes/useRoutes'
import { ActiveSelectField, useActiveSelectField } from '../../context/ActiveSelectFieldProvider'
import { isFrsRoute, mapToCurrencyToContentfulResource } from '../../Utils/frs-helpers'
import CurrencyIcon from '../../Icons/CurrencyIcon'
import Currency from './Currency'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'

export default function CurrencySelector() {
  const {
    state: { selectedCurrency },
  } = useTravelSearchContext()
  const { isRoutesLoading, selectedRoute } = useRoutes()
  const { activeField, toggleField, closeIfActive } = useActiveSelectField()
  const { t } = useTranslation()
  return (
    <div
      className={clsx(
        'ts-h-[58px] ts-w-full ts-col-span-12 md:ts-col-span-6 lg:ts-col-auto ts-box-border ts-border lg:ts-border-r-0 ts-border-solid ts-border-cvi-grey-grey200',
        !isFrsRoute(selectedRoute?.routeCode ?? '') && 'ts-hidden'
      )}
    >
      <SelectField
        dataAttrList={[{ name: 'selected-currency', value: `${selectedCurrency}` }]}
        disabled={!isFrsRoute(selectedRoute?.routeCode ?? '')}
        title={t('CURRENCY')}
        isLoading={isRoutesLoading}
        isOpen={activeField === ActiveSelectField.CURRENCY}
        fieldName="currency"
        value={mapToCurrencyToContentfulResource(selectedCurrency, t)}
        icon={<CurrencyIcon size="md" />}
        onClick={(clickedOutside: boolean) => {
          !isRoutesLoading && toggleField(ActiveSelectField.CURRENCY, clickedOutside)
        }}
        onClose={() => {
          closeIfActive(ActiveSelectField.CURRENCY)
        }}
      >
        <Currency />
      </SelectField>
    </div>
  )
}
